import React from 'react';
import { Outlet } from 'react-router-dom';
import CanStoreTab from 'containers/can-store/components/CanStoreTab';
import ModernHeader from 'containers/can-store/modernTemplate/ModernHeader';
import ModernNavBar from 'containers/can-store/modernTemplate/ModernNavBar';
import ModernFooter from 'containers/can-store/modernTemplate/ModernFooter';
import Box from '@mui/material/Box';
import 'styles/can-store/modern-template/modernTemplate.module.css';

function ModernTemplateLayout(): JSX.Element {
	return (
		<>
			<CanStoreTab />
			<Box
				component="main"
				sx={{
					display: 'flex',
					flexDirection: 'column',
					gap: '1.5rem',
					marginTop: '3rem',
				}}
			>
				<Box component="header" sx={{ width: 'var(--csmd-cl-width-main)', margin: 'auto' }}>
					<ModernHeader />
				</Box>
				<Box component="header" sx={{ width: 'var(--csmd-cl-width-main)', margin: 'auto' }}>
					<ModernNavBar />
				</Box>
				<Box component="section" sx={{ width: 'var(--csmd-cl-width-main)', margin: 'auto' }}>
					<Outlet />
				</Box>
				<Box component="footer" sx={{ backgroundColor: 'var(--csmd-cl-bg-footer)' }}>
					<ModernFooter />
				</Box>
			</Box>
		</>
	);
}

export default ModernTemplateLayout;
